import { useEffect, useState } from "react";
import { FormatNumber } from "utils/numberUtils";
import { IUnit } from "Dashboard/domain/IUnit";
import { useSelector } from "react-redux";
import { commonService } from "Dashboard/services/common.service";
import { useAppDispatch } from "hooks/hooks";
import ConcreteBaseInput from "./ConcreteBaseInput";
import DeleteRowModal from "./DeleteRowModal";
import { selectState, setUpdateInputItemPopover } from "../inputSlice";
import { usePartnerOptions } from "Dashboard/scenes/Partners/hooks/PartnerOptions";
import UpdateConcreteBaseInputItemPopover from "./UpdateConcreteBaseInputItemPopover";
import Popover from "components/Popover/Popover";

interface IProps {
  lastTableElementRef?: any;
  handleScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  doSortBy: (newSortColumn: string) => void;
}

const TopSection = ({ lastTableElementRef, handleScroll, doSortBy }: IProps) => {
  const dispatch = useAppDispatch();
  const { inputs, totalPrice, quantityAmountRemaining, quantityAmountTotal, updateInputItemPopover }
    = useSelector(selectState);
  const [, setUnits] = useState<IUnit[]>([]);
  const partnerOptions = usePartnerOptions();

  useEffect(() => {
    async function getUnits() {
      try {
        const units = await commonService.getUnits({});
        setUnits(units);
      } catch (error) {
        console.log(error);
      }
    }

    getUnits();
  }, []);

  return (
    <div className="lager-top-section concreteBase-top-section">
      <div className="g-grid g-header">
        <div className="row">
          <div className="col lowercase center separator-line">br.računa</div>
          <div className="col lowercase center separator-line">br.otpremnice</div>
          <div className="col lowercase center separator-line">šifra art.</div>
          <div className="col separator-line"></div>
          <div className="col lowercase center separator-line clickable"
            onClick={() => doSortBy("NAME")}>ime
          </div>
          <div className="col lowercase center separator-line quantity-for-output">
            količina izdajem
          </div>
          <div className="col lowercase center separator-line">dobavljač</div>
          <div className="col lowercase center separator-line">količina</div>
          <div className="col lowercase center separator-line">mera</div>
          <div className="col lowercase center separator-line">cena po jed.</div>
          <div className="col lowercase center separator-line">cena transporta</div>
          <div className="col lowercase center separator-line">kol ostalo</div>
          <div className="col lowercase center separator-line">ukupno</div>
          <div className="col lowercase center separator-line clickable"
            onClick={() => doSortBy("DATE")}>datum ulaza
          </div>
          <div className="col separator-line"></div>
          <div className="col lowercase center separator-line">dovezao</div>
          <div className="col lowercase center separator-line">napomena</div>
        </div>
      </div>

      <div className="g-grid g-content" onScroll={handleScroll}>
        {inputs &&
          inputs.map((input, index) => {
            const isLast = index === inputs.length - 1;
            return <ConcreteBaseInput
              lastTableElementRef={isLast ? lastTableElementRef : undefined}
              key={`${input.inputId}`}
              input={input}
              partnerOptions={partnerOptions}
              index={index} />;
          })}

        <Popover
          isOpen={updateInputItemPopover.isOpen}
          onClose={() => {
            dispatch(setUpdateInputItemPopover({ isOpen: false, itemRowIndex: -1 }));
          }}
          direction="right"
          title="Šifra, ime, cena artikla"
          arrowStyle={{ left: "-15px", top: "50px" }}
          position={{
            top: updateInputItemPopover.top,
            left: updateInputItemPopover.left,
            offsetLeft: 50,
            offsetTop: -60,
          }}
        >
          <UpdateConcreteBaseInputItemPopover />
        </Popover>
      </div>

      <div className="g-grid g-footer">
        <div className="row">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div className="col">
            <div className="bg-item bg-item-important right">
              <span className="text-small">{FormatNumber(quantityAmountTotal)}</span>
            </div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div className="col">
            <div className="bg-item bg-item-important right danger">
              <span className="text-small">{FormatNumber(quantityAmountRemaining)}</span>
            </div>
          </div>
          <div className="col total-price">
            <div className="bg-item bg-item-important left">
              <span>{FormatNumber(totalPrice)} rsd</span>
            </div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <DeleteRowModal />
    </div>
  );
};

export default TopSection;
